import { css } from '@linaria/core';

export const overlayStyles = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  user-select: none;
  overflow: hidden;
  font-size: var(--fabric-typography-body-md-font-size);
  font-family: inherit;
  line-height: var(--fabric-typography-body-md-line-height);
  /* Whitespace handling must match textarea */
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: break-word;
  /* All overlay text is invisible — only the CSS decoration on the URL span shows */
  color: transparent;
`;

export const overlayContentStyles = css`
  transform-origin: top left;
  will-change: transform;
`;

export const urlUnderlineStyles = css`
  color: transparent;
  text-decoration: underline;
  text-decoration-style: wavy;
  text-decoration-color: var(--fabric-color-status-error-default);
`;
